import {
    POST_OCI_ENABLE_DISABLE_ALERTS,
    POST_OCI_ENABLE_DISABLE_ALERTS_FAIL,
    POST_OCI_ENABLE_DISABLE_ALERTS_SUCCESS,
    POST_OCI_CREATE_RESOURCE_ALERTS,
    POST_OCI_CREATE_RESOURCE_ALERTS_FAIL,
    POST_OCI_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_OCI_CREATE_DYNAMIC_ALERT,
    POST_OCI_CREATE_DYNAMIC_ALERT_FAIL,
    POST_OCI_CREATE_DYNAMIC_ALERT_SUCCESS,
    GET_OCI_ALERTS,
    GET_OCI_ALERTS_FAIL,
    GET_OCI_ALERTS_SUCCESS,
    GET_OCI_DYNAMIC_ALERTS,
    GET_OCI_DYNAMIC_ALERTS_FAIL,
    GET_OCI_DYNAMIC_ALERTS_SUCCESS,
    GET_OCI_MISSING_DYNAMIC_ALERTS,
    GET_OCI_MISSING_DYNAMIC_ALERTS_FAIL,
    GET_OCI_MISSING_DYNAMIC_ALERTS_SUCCESS,
    GET_OCI_DEFAULT_THRESHOLD,
    GET_OCI_DEFAULT_THRESHOLD_FAIL,
    GET_OCI_DEFAULT_THRESHOLD_SUCCESS,
    GET_OCI_RESOURCE_BY_ID,
    GET_OCI_RESOURCE_BY_ID_FAIL,
    GET_OCI_RESOURCE_BY_ID_SUCCESS,
    GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
    GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
    GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
    POST_OCI_ALERT,
    POST_OCI_ALERT_FAIL,
    POST_OCI_ALERT_SUCCESS,
    GET_OCI_RESCAN,
    GET_OCI_RESCAN_FAIL,
    GET_OCI_RESCAN_SUCCESS,
    GET_OCI_MISSING_ALERT_BY_RESOURCE_ID,
    GET_OCI_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
    GET_OCI_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
    GET_OCI_ALL_RESOURCE_ALERTS_PAGE,
    GET_OCI_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    GET_OCI_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE,
    GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
    GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
    POST_OCI_SERVICE_MAPPING,
    POST_OCI_SERVICE_MAPPING_FAIL,
    POST_OCI_SERVICE_MAPPING_SUCCESS,
    POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    GET_OCI_RESOURCES,
    GET_OCI_RESOURCES_FAIL,
    GET_OCI_RESOURCES_SUCCESS,
    GET_ALL_ORG_OCI_RESOURCE_TYPES,
    GET_ALL_ORG_OCI_RESOURCE_TYPES_FAIL,
    GET_ALL_ORG_OCI_RESOURCE_TYPES_SUCCESS,
    GET_RESCAN_STATUS_OCI,
    GET_RESCAN_STATUS_OCI_FAIL,
    GET_RESCAN_STATUS_OCI_SUCCESS,
    POST_UPDATE_OCI_THRESHOLD,
    POST_UPDATE_OCI_THRESHOLD_FAIL,
    POST_UPDATE_OCI_THRESHOLD_SUCCESS,
    POST_ENABLE_DISABLE_OCI_THRESHOLD,
    POST_ENABLE_DISABLE_OCI_THRESHOLD_FAIL,
    POST_ENABLE_DISABLE_OCI_THRESHOLD_SUCCESS,
    GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_OCI_THRESHOLD,
    GET_OCI_THRESHOLD_FAIL,
    GET_OCI_THRESHOLD_SUCCESS,
} from "./actionTypes";

export const postEnableDisableOciThreshold = (data) => ({
    type: POST_ENABLE_DISABLE_OCI_THRESHOLD,
    payload: data,
})

export const postEnableDisableOciThresholdFail = error => ({
    type: POST_ENABLE_DISABLE_OCI_THRESHOLD_FAIL,
    payload: error,
})

export const postEnableDisableOciThresholdSuccess = (response) => ({
    type: POST_ENABLE_DISABLE_OCI_THRESHOLD_SUCCESS,
    payload: response,
})

export const postUpdateOciThreshold = (data) => ({
    type: POST_UPDATE_OCI_THRESHOLD,
    payload: data
})

export const postUpdateOciThresholdFail = error => ({
    type: POST_UPDATE_OCI_THRESHOLD_FAIL,
    payload: error
})

export const postUpdateOciThresholdSuccess = (response) => ({
    type: POST_UPDATE_OCI_THRESHOLD_SUCCESS,
    payload: response
})

export const getRescanStatusOci = (data) => ({
    type: GET_RESCAN_STATUS_OCI,
    payload: data
})

export const getRescanStatusOciFail = error => ({
    type: GET_RESCAN_STATUS_OCI_FAIL,
    payload: error
})

export const getRescanStatusOciSuccess = (oci_rescan_status) => ({
    type: GET_RESCAN_STATUS_OCI_SUCCESS,
    payload: oci_rescan_status
})

export const getOciRefresh = () => ({
    type: GET_OCI_RESCAN,
    payload: []
})

export const getOciRefreshFail = error => ({
    type: GET_OCI_RESCAN_FAIL,
    payload: error
})

export const getOciRefreshSuccess = (data) => ({
    type: GET_OCI_RESCAN_SUCCESS,
    payload: data
})

export const getOciResources = () => ({
    type: GET_OCI_RESOURCES,
})

export const getOciResourcesFail = error => ({
    type: GET_OCI_RESOURCES_FAIL,
    payload: error
})

export const getOciResourcesSuccess = oci_resources => ({
    type: GET_OCI_RESOURCES_SUCCESS,
    payload: oci_resources
})

export const getOciMissingAlertByResourceId = (monitored_resource_id) => ({
    type: GET_OCI_MISSING_ALERT_BY_RESOURCE_ID,
    payload: monitored_resource_id
})

export const getOciMissingAlertByResourceIdFail = error => ({
    type: GET_OCI_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getOciMissingAlertsByResourceIdSuccess = (response) => ({
    type: GET_OCI_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
    payload: response
})

export const getOciAllResourceAlertsPage = (data) => ({
    type: GET_OCI_ALL_RESOURCE_ALERTS_PAGE,
    payload: data
})

export const getOciAllResourceAlertsPageFail = error => ({
    type: GET_OCI_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error
})

export const getOciAllResourceAlertsPageSuccess = (oci_all_resource_alerts) => ({
    type: GET_OCI_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: oci_all_resource_alerts
})

export const getOciAllResourceAlertsCountPage = (data) => ({
    type: GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE,
    payload: data
})

export const getOciAllResourceAlertsCountPageFail = error => ({
    type: GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
    payload: error
})

export const getOciAllResourceAlertsCountPageSuccess = (oci_all_resource_alerts_count) => ({
    type: GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
    payload: oci_all_resource_alerts_count
})

export const postOciAlert = (data) => ({
    type: POST_OCI_ALERT,
    payload: data
})

export const postOciAlertFail = error => ({
    type: POST_OCI_ALERT_FAIL,
    payload: error
})

export const postOciAlertSuccess = (response) => ({
    type: POST_OCI_ALERT_SUCCESS,
    payload: response
})

export const postOciServiceMapping = (data) => ({
    type: POST_OCI_SERVICE_MAPPING,
    payload: data
})

export const postOciServiceMappingFail = error => ({
    type: POST_OCI_SERVICE_MAPPING_FAIL,
    payload: error
})

export const postOciServiceMappingSuccess = (response) => ({
    type: POST_OCI_SERVICE_MAPPING_SUCCESS,
    payload: response
})

export const postOciResourceOpsGenieTeamMapping = (data) => ({
    type: POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: data
})

export const postOciResourceOpsGenieTeamMappingFail = error => ({
    type: POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    payload: error
})

export const postOciResourceOpsGenieTeamMappingSuccess = (response) => ({
    type: POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    payload: response
})

export const postOciResourcePagerdutyMapping = (data) => ({
    type: POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    payload: data
})

export const postOciResourcePagerdutyMappingFail = error => ({
    type: POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    payload: error
})

export const postOciResourcePagerdutyMappingSuccess = (response) => ({
    type: POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    payload: response
})

export const getAllOrgOciResourceTypes = () => ({
    type: GET_ALL_ORG_OCI_RESOURCE_TYPES
})

export const getAllOrgOciResourceTypesFail = error => ({
    type: GET_ALL_ORG_OCI_RESOURCE_TYPES_FAIL,
    payload: error
})

export const getAllOrgOciResourceTypesSuccess = orgOciResourceTypes => ({
    type: GET_ALL_ORG_OCI_RESOURCE_TYPES_SUCCESS,
    payload: orgOciResourceTypes
})


export const postOciEnableDisableAlerts = (data) => ({
    type: POST_OCI_ENABLE_DISABLE_ALERTS,
    payload: data
})

export const postOciEnableDisableAlertsFail = error =>({
    type: POST_OCI_ENABLE_DISABLE_ALERTS_FAIL,
    payload: error
})

export const postOciEnableDisableAlertsSuccess = (response) => ({
    type: POST_OCI_ENABLE_DISABLE_ALERTS_SUCCESS,
    payload: response
})

export const postOciCreateResourceAlerts = data => ({
    type: POST_OCI_CREATE_RESOURCE_ALERTS,
    payload: data
})

export const postOciCreateResourceAlertsFail = error => ({
    type: POST_OCI_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error
})

export const postOciCreateResourceAlertsSuccess = (response) => ({
    type: POST_OCI_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: response
})

export const postOciCreateDynamicAlert = data =>({
    type: POST_OCI_CREATE_DYNAMIC_ALERT,
    payload: data
})

export const postOciCreateDynamicAlertSuccess = (response) => ({
    type: POST_OCI_CREATE_DYNAMIC_ALERT_SUCCESS,
    payload: response
})

export const postOciCreateDynamicAlertFail = error => ({
    type: POST_OCI_CREATE_DYNAMIC_ALERT_FAIL,
    payload: error
})

export const getOciAlerts = (monitored_resource_id) => (
    {
        type: GET_OCI_ALERTS,
        payload: monitored_resource_id
    }
)

export const getOciAlertsSuccess = oci_alerts => ({
    type: GET_OCI_ALERTS_SUCCESS,
    payload: oci_alerts
})

export const getOciAlertsFail = error => ({
    type: GET_OCI_ALERTS_FAIL,
    payload: error
})

export const getOciDynamicAlerts = (monitored_resource_id) => ({
    type: GET_OCI_DYNAMIC_ALERTS,
    payload: monitored_resource_id
})

export const getOciDynamicAlertsSuccess = oci_dynamic_alerts => ({
    type: GET_OCI_DYNAMIC_ALERTS_SUCCESS,
    payload: oci_dynamic_alerts
})

export const getOciDynamicAlertsFail = error => ({
    type: GET_OCI_DYNAMIC_ALERTS_FAIL,
    payload: error
})

export const getOciMissingDynamicAlerts = (monitored_resource_id) => ({
    type: GET_OCI_MISSING_DYNAMIC_ALERTS,
    payload: monitored_resource_id
})

export const getOciMissingDynamicAlertsFail = error => ({
    type: GET_OCI_MISSING_DYNAMIC_ALERTS_FAIL,
    payload: error
})

export const getOciMissingDynamicAlertsSuccess = oci_missing_dynamic_alerts => ({
    type: GET_OCI_MISSING_DYNAMIC_ALERTS_SUCCESS,
    payload: oci_missing_dynamic_alerts
})

export const getOciDefaultThreshold = threshold_type => ({
    type: GET_OCI_DEFAULT_THRESHOLD,
    payload: threshold_type
})

export const getOciDefaultThresholdFail = error => ({
    type: GET_OCI_DEFAULT_THRESHOLD_FAIL,
    payload: error
})

export const getOciDefaultThresholdSuccess = defaultThreshold => ({
    type: GET_OCI_DEFAULT_THRESHOLD_SUCCESS,
    payload: defaultThreshold
})

export const getOciThreshold = metric_id => ({
    type: GET_OCI_THRESHOLD,
    payload: metric_id
})

export const getOciThresholdFail = error => ({
    type: GET_OCI_THRESHOLD_FAIL,
    payload: error
})

export const getOciThresholdSuccess = ociThreshold => ({
    type: GET_OCI_THRESHOLD_SUCCESS,
    payload: ociThreshold
})

export const getOciResourceById = monitored_resource_id => ({
    type: GET_OCI_RESOURCE_BY_ID,
    payload: monitored_resource_id
})

export const getOciResourceByIdSuccess = oci_resource => ({
    type: GET_OCI_RESOURCE_BY_ID_SUCCESS,
    payload: oci_resource
})

export const getOciResourceByIdFail = error => ({
    type: GET_OCI_RESOURCE_BY_ID_FAIL,
    payload: error
})

export const getOciResourcesDefaultThresholdById = monitored_resource_id => ({
        type: GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
        payload: monitored_resource_id
})

export const getOciResourcesDefaultThresholdByIdSuccess = oci_resource_default_threshold => ({
    type: GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
    payload: oci_resource_default_threshold
})

export const getOciResourcesDefaultThresholdByIdFail = error => ({
    type: GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
    payload: error
})

export const getMissingOciAlertsByResourceID = data => ({
    type: GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getMissingOciAlertsByResourceIDSuccess = oci_resource_missing_alerts => ({
    type: GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: oci_resource_missing_alerts,
})

export const getMissingOciAlertsByResourceIDFail = error => ({
    type: GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error,
})
